import { Button, Dropdown } from "@alm/flow-ds/components";
import { logoutAction } from "data/app/appActions";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

interface Props {
	username: string;
}

const ProfileMenu = ({ username }: Props) => {
	const history = useHistory();
	const { t } = useTranslation();

	const dispatch = useDispatch();

	return (
		<Dropdown
			id="profileMenu__dropdown"
			menuBtn={
				<Button className="taskbar__item-profile">
					<div className="taskbar__item-profile-image">
						{(username[0] || "").toUpperCase()}
					</div>
					<div className="taskbar__item-profile-username">
						{username}
					</div>
				</Button>
			}
			align="right">
			<Button
				name="profile"
				label={t("main.taskBar.profile")}
				className="dropdown-item btn-basic--default"
				value="profile"
				onClick={() => history.push("/profile")}
			/>
			<Button
				name="logout"
				label={t("main.taskBar.logout")}
				className="dropdown-item btn-basic--default"
				value="logout"
				onClick={() => dispatch(logoutAction())}
			/>
		</Dropdown>
	);
};

export default ProfileMenu;
